import { gql } from "@apollo/client";

export const GET_EQUIPO_BY_ID_EVALUACION = gql`
query confirmacionEquipoByIdEvaluacion ($idEvaluacion: Int!) {
     confirmacionEquipoByIdEvaluacion (idEvaluacion: $idEvaluacion){
        idConfirmacionEquipo
        idProfesionalNavigation{
          nombre
          apellido
        }
        idFrecuenciaProfesionalNavigation{
          descripccion
        }
        idFiguraProfesionalNavigation{
          descripcion
        }
        idFrecuenciaProfesional
        idFiguraProfesional
        idProfesional
    }
}`;

export const adaptEquipoArray = (
equipo) =>
{
  return structuredClone(equipo?.confirmacionEquipoByIdEvaluacion || [])?.
  map((personal) => ({
    id: personal?.idConfirmacionEquipo,
    profesional: personal?.idProfesionalNavigation !== null && `${personal?.idProfesionalNavigation?.apellido}, ${personal?.idProfesionalNavigation?.nombre}`,
    frecuencia: personal?.idFrecuenciaProfesionalNavigation?.descripccion,
    tipoProfesional: personal?.idFiguraProfesionalNavigation?.descripcion,
    idTipoProfesional: personal?.idFiguraProfesional,
    idFrecuencia: personal?.idFrecuenciaProfesional,
    idProfesional: personal?.idProfesional,
    nombreCompleto: personal?.idProfesionalNavigation !== null && `${personal?.idProfesionalNavigation?.apellido}, ${personal?.idProfesionalNavigation?.nombre}`
  }));
};